var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"11"}},[_c('ReportSitesComplete')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }